<svg height="0px" width="0px">
  <defs>
    <filter id="{{id}}" color-interpolation-filters="sRGB">
      <feColorMatrix type="matrix"  [attr.values]="matrix"/>
    </filter>
  </defs>
</svg>